// ---------------------------------------------------------------------
// Popup Windows
// ---------------------------------------------------------------------

/**
 * @param {string} name
 * @param {string} url
 * @param {string|number} w
 * @param {string|number} h
 * @param {string|number} l
 * @param {boolean} t
 * @param {boolean} statusbar
 */
function popupWindow (name, url, w, h, l, t, statusbar) {
    var opts = "scrollbars,resizable";
    if (statusbar) opts += ",status";
    opts += ",width=" + w + ",height=" + h;
    opts += ",left=" + l + ",top=" + t;
    
    var popup = window.open(url, name, opts);
    popup.focus();
    return false;
};

// ---------------------------------------------------------------------

window["popupWindow"] = popupWindow;

// ---------------------------------------------------------------------

